<template>
  <section class="solution-header">
    <div class="container">
      <div class="row">
        <div
          class="col-12"
          :class="{
            'col-lg-12': !solution.description || !solution.video, 'col-lg-6': solution.description || solution.video
          }"
        >
          <h2 class="h3">{{ solution.title }}</h2>
          <div v-html="solution.description" />
        </div>
        <div class="col-12" :class="solution.description ? 'col-lg-6' : 'wide-video'" v-if="solution.video">
          <iframe width="100%" height="100%" :src="solution.video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  props: {
    solution: {
      title: String,
      description: HTMLElement,
      video: String
    }
  }
}
</script>G
